import {Base} from "./base";
import {userService} from "@/services/user";

class CommpatService extends Base {
  constructor() {
    super();
    this.lastBindTime = 0;
  }


  /**
   * 列表
   * @returns {Promise<*>}
   */
  async list() {
    return await userService.compatList();
  }

  async detail(compatId) {
    let list = await this.list();
    return list.find(r => r.compatId === compatId) || {};
  }


  /**
   * 添加就诊人
   * @param options.compatIdcard
   * @param options.compatName
   * @param options.cid
   * @param options.captcha
   * @returns {Promise<*>}
   */
  async add(options) {
    return await this.$http('nethos.pat.compat.add.v2', options);
  }


  /**
   * 修改资料
   * @param options.compatId
   * @param options.maritalStatus
   * @param options.compatMobile
   * @param options.cid
   * @param options.captcha
   * @returns {Promise<boolean>}
   */
  async modify(options) {
    const {code} = await this.$http('nethos.pat.compat.modify.v2', options)
    return code === '0';
  }

  /**
   * 就诊卡解绑
   * @param compatRecordId
   * @returns {Promise<boolean>}
   */
  async unbind(compatRecordId) {
    const {code} = await this.$http('nethos.pat.compat.medicalrecord.unbind', {
      compatRecordId
    });
    return code === '0'
  }

  /**
   * 校验就诊卡，是否新建或绑定
   * @param compatId
   * @param bookHosId
   * @returns {Promise<*>}
   */
  async check({compatId, bookHosId}) {
    const {code, obj = ""} = await this.$http('nethos.book.compat.bind.check', {compatId, bookHosId});
    return code === '0' ? obj : ""
  }

  /**
   * 绑定就诊卡
   * @param compatId
   * @param bookHosId
   * @returns {Promise<void>}
   */
  async bind({compatId, bookHosId}) {
    let now = Date.now();
    if (now - this.lastBindTime < 60 * 1000) return bus.$emit('msg', '操作频繁，请1分钟后再试');
    this.lastBindTime = now;
    const {code, obj = {}} = await this.$http('nethos.book.compat.bind', {compatId, bookHosId});
    return code === '0' ? obj : code;
  }

  /**
   * 新建就诊卡
   * @param compatId
   * @param bookHosId
   * @param address
   * @param patHeight
   * @param patWeight
   * @returns {Promise<void>}
   */
  async new({compatId, bookHosId, address, patHeight, patWeight, patWorkCode}) {
    const {code, obj = {}} = await this.$http('nethos.book.compat.bind.new', {
      compatId,
      bookHosId,
      address,
      patHeight,
      patWeight,
      patWorkCode
    });
    return code === '0' ? obj : {}
  }

  /**
   * 63.就诊人姓名和证件号证件号校验
   * @param options.compatId
   * @param options.idCardFront
   * @param options.idCardBack
   * @param options.compatName
   * @param options.compatIdcard
   * @returns {Promise<void>}
   */
  async idCardCheck(options) {
    const {code, msg} = await this.$http('nethos.pat.compat.credentials.check', options, {}, {
      showError: false
    });
    return code === '0' ? true : msg;
  }

  async mobile({compatId}) {
    const {code} = await this.$http('nethos.book.patient.mobile.modify', {
      compatId
    });
    return code === '0';
  }

  async mobileV2({compatId, cid, captcha}) {
    const {code} = await this.$http('nethos.book.patient.mobile.modify.v2', {
      compatId, cid, captcha
    });
    return code === '0';
  }

  /**
   * 修改预留手机号
   * @param compatId
   * @param cid
   * @param captcha
   * @param idCard
   * @returns {Promise<boolean>}
   */
  async mobileV3({compatId, cid, captcha, idCard}) {
    const {code} = await this.$http('nethos.book.patient.mobile.modify.v3', {
      compatId, cid, captcha, idCard
    });
    return code === '0';
  }

  // {"service":"nethos.pat.compat.countJudge"}
  async judge() {
    return await this.$http('nethos.pat.compat.countJudge', {}, {}, {showError: false});
  }
}

export const commpatService = new CommpatService();



// WEBPACK FOOTER //
// ./src/services/commpat.js